import React from 'react'
import { BackHandler } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import ServerDown from '@zet/design-system/svg/ServerDown'
import { i18n } from '@zet/localization'

import { ErrorScreenLayout } from './components/errorScreenLayout'

export const ServerDownScreen = () => {
  return (
    <Stack>
      <ErrorScreenLayout
        ErrorIconComponent={ServerDown}
        title={i18n.t('errorScreens.willBeBack')}
        description={i18n.t('errorScreens.willBeBackDesc')}
        buttonTitle={i18n.t('errorScreens.exitApp')}
        buttonOnPress={() => BackHandler.exitApp()}
      />
    </Stack>
  )
}
